<template>

<div>
    <!--<input class="file" name="file" type="file" accept="video/*" @change="updateFace" />
     <van-loading size="24px" type="spinner" color="#1989fa" id="upLoading" v-show="showRentPrise">上传中,请稍等...</van-loading>-->
    <input class="file" name="file" type="file" accept="aplication/zip" @change="updateFace" />
     <van-loading size="24px" type="spinner" color="#1989fa" id="upLoading" v-show="showRentPrise">上传中,请稍等...</van-loading>
 
   

 </div>

</template>

<script>
import { Dialog } from 'vant';
 export default {
   data() {
   return {
      AUDIO: '', // 视频地址
      showRentPrise:false
   };
  },
methods: {
  updateFace(e) {
    var that = this;
    var userId = sessionStorage.getItem('userId')
    console.log("userid:"+userId)
    that.showRentPrise = true;
    const file = e.target.files[0] || e.dataTransfer.files[0]
    let URL = window.URL || window.webkitURL; // 获取当前域名地址
    this.AUDIO = URL.createObjectURL(file);   // 拼接 URL + file 并转成 blob地址
    console.log(file.path);
    var params = new URLSearchParams()
                params.append('file', file)
    var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加 到FormData里面，这样就可以直接把formData作为参数传递了
              if (file) {
                  formData.append("file", file); //接口需要传递的参数
                  formData.append("userId", userId); 
              }
    let potss = formData;         
    let urls = "http://127.0.0.1:8080/upload/uploadVideo";
                this.$axios
                    .post(urls, potss)
                    .then(function(res) {
                         that.showRentPrise = false;
                        var data = res.data
                        console.log(data)
                        if(data === 'error'){
                            Dialog.alert({
                            message: '您已上传过作品，请勿重复上传',
                          }).then(() => {
                            // on close
                          });
                        } else {
                              Dialog.alert({
                            message: '上传成功',
                          }).then(() => {
                            // on close
                          });
                        }
                        
                    
                    })
                    .catch(function(err) {
                        console.log(err);
                    });
  },
    
}

}
</script>
